import { PaperLayout, PrimaryTitle } from '../../presentation';
import './entity-detail-header.scss';

interface IProps {
  referenceId?: string | null;
  title: string;
}

export const EntityHeader = ({ referenceId, title }: IProps) => {
  return (
    <PaperLayout className="entity-detail-header">
      <PrimaryTitle variant="h3">
        <span className="title">
          {title}
          {referenceId ? ':' : false} {referenceId ? referenceId : false}
        </span>
      </PrimaryTitle>
    </PaperLayout>
  );
};
